import { udpdateReview } from "../../utils";

export function implementTablist(container: Element) {

	let firstTab: HTMLElement | null = null;
	let lastTab: HTMLElement | null = null;


	const tabs: HTMLElement[] = Array.from(container.querySelectorAll("[role=tab]"));

	const tabpanels: HTMLElement[] = [];

	for (const tab of tabs) {
		const tabpanel = document.getElementById(tab.getAttribute("aria-controls")!);

		tab.tabIndex = -1;
		tab.setAttribute("aria-selected", "false");
		tabpanels.push(tabpanel!);

		tab.addEventListener("keydown", onKeyDown);
		tab.addEventListener("click", onClick);

		if (firstTab === null) firstTab = tab;
		lastTab = tab;
	}

	setSelectedTab(firstTab as HTMLElement, false);

	function onKeyDown(event: KeyboardEvent) {
		const target = event.currentTarget as HTMLElement;

		if(target.classList.contains("gct-checkout-tab-disabled")) return;
		/* if(target.id !== "bnt-review" && !validateDeliveryForm()) return;
		if(target.id !== "bnt-review" && !validateBillingForm()) return; */
		if(target.id === "bnt-review") udpdateReview();

		switch (event.key) {
			case "ArrowUp":
				setSelectedToPreviousTab(target);
				break;
			case "ArrowDown":
				setSelectedToNextTab(target);
				break;
			case "Home":
				setSelectedTab(firstTab as HTMLElement);
				break;
			case "End":
				setSelectedTab(lastTab as HTMLElement);
				break;
			default:
				return;
		}

		event.stopPropagation();
		event.preventDefault();
	}

	function onClick(event: Event) {
		const tab = event.target as HTMLElement;
		if(tab.classList.contains("gct-checkout-tab-disabled")) return;
		/* if(tab.id !== "bnt-review" && !validateDeliveryForm()) return;
		if(tab.id !== "bnt-review" && !validateBillingForm()) return; */
		if(tab.id === "bnt-review") udpdateReview();
		setSelectedTab(tab);
	}


	function setSelectedTab(currentTab: HTMLElement, setFocus: boolean = true) {
		for (let i = 0; i < tabs.length; ++i) {
			const tab = tabs[i];
			if (currentTab === tab) {
				tab.setAttribute("aria-selected", "true");
				tab.tabIndex = 0;
				tabpanels[i].classList.remove("gct-d-none");
				tab.classList.add("gct-checkout-tab");
				if (setFocus) tab.focus();
			} else {
				tab.setAttribute("aria-selected", "false");
				tab.tabIndex = -1;
				tabpanels[i].classList.add("gct-d-none");
				tab.classList.remove("gct-checkout-tab");
			}
		}
	}


	function setSelectedToPreviousTab(currentTab: HTMLElement) {
		if (currentTab === firstTab) {
			setSelectedTab(lastTab as HTMLInputElement);
		} else {
			const index = tabs.indexOf(currentTab);
			setSelectedTab(tabs[index - 1]);
		}
	}

	function setSelectedToNextTab(currentTab: HTMLElement) {
		if (currentTab === lastTab) {
			setSelectedTab(firstTab as HTMLElement);
		} else {
			const index = tabs.indexOf(currentTab);
			setSelectedTab(tabs[index + 1]);
		}
	}
}
